/* eslint-disable prefer-destructuring */
import { DEFAULT_THEME } from '@mantine/core';
import { fillText } from '../../src/Utils';
import { SatoshiVariable } from '../../pages/_app';
import { TIER_COLOR_SWATCH } from '../GradientPicker/GradientPicker';
import { SONG_DATA } from './SongGrid';

export const getDrakeImage = async (order: number[]) => {
  const asBlob = false;
  const canvas = document.createElement('canvas');

  const context = canvas.getContext('2d');
  if (!context) {
    return null;
  }

  const pageWidth = 1080;
  const pageHeight = 1920;
  const darkMode = true;

  canvas.width = pageWidth;
  canvas.height = pageHeight;

  context.fillStyle = darkMode ? DEFAULT_THEME.colors.dark[8] : DEFAULT_THEME.colors.gray[1];
  context.fillRect(0, 0, pageWidth, pageHeight);

  context.textAlign = 'center';
  // context.textBaseline = "middle";
  context.textBaseline = 'bottom';

  context.fillStyle = '#B197FC';
  fillText(context, 'Drake', {
    font: SatoshiVariable.style.fontFamily,
    rect: {
      x: 180,
      y: 80,
      width: 108,
      height: 80,
    },
    minFontSize: 70,
    lineHeight: 1.2,
  });
  context.fillStyle = DEFAULT_THEME.colors.pink[6];
  fillText(context, 'Kendrick', {
    font: SatoshiVariable.style.fontFamily,
    rect: {
      x: 500,
      y: 80,
      width: 108,
      height: 80,
    },
    minFontSize: 70,
    lineHeight: 1.2,
  });

  context.fillStyle = '#FFFFFF';
  fillText(context, 'vs', {
    font: SatoshiVariable.style.fontFamily,
    rect: {
      x: 315,
      y: 80,
      width: 1080,
      height: 80,
    },
    minFontSize: 70,
    lineHeight: 1.2,
  });

  fillText(context, 'Diss Tracks', {
    font: SatoshiVariable.style.fontFamily,
    rect: {
      x: 815,
      y: 80,
      width: 1080,
      height: 80,
    },
    minFontSize: 70,
    lineHeight: 1.2,
  });

  fillText(context, 'Create your own @', {
    font: SatoshiVariable.style.fontFamily,
    rect: {
      x: 320,
      y: 1800,
      width: 1200,
      height: 80,
    },
    minFontSize: 45,
    maxFontSize: 45,
  });
  context.fillStyle = DEFAULT_THEME.colors.violet[3];
  fillText(context, 'lomolist.com', {
    font: SatoshiVariable.style.fontFamily,
    rect: {
      x: 660,
      y: 1800,
      width: 1200,
      height: 80,
    },
    minFontSize: 50,
    maxFontSize: 50,
  });

  const imagePromises = [];
  imagePromises.push(
    new Promise<void>((resolve) => {
      const boxHeight = 220;
      const x = 800;
      const y = 1730;
      const image = new Image(boxHeight, boxHeight);
      image.setAttribute('crossorigin', 'anonymous'); // works for me
      image.src = 'https://api.lomolist.com/storage/v1/object/public/uploads/LogoMain.png';
      image.addEventListener('load', (e) => {
        context.save();
        function roundedImage(width: number, height: number, radius: number) {
          if (!context) return;
          context.beginPath();
          context.moveTo(x + radius, y);
          context.lineTo(x + width - radius, y);
          context.quadraticCurveTo(x + width, y, x + width, y + radius);
          context.lineTo(x + width, y + height - radius);
          context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
          context.lineTo(x + radius, y + height);
          context.quadraticCurveTo(x, y + height, x, y + height - radius);
          context.lineTo(x, y + radius);
          context.quadraticCurveTo(x, y, x + radius, y);
          context.closePath();
        }

        roundedImage(boxHeight, boxHeight, 6);
        context.clip();
        context.drawImage(image, x, y, boxHeight, boxHeight);

        context.restore();
        resolve();
      });

      image.addEventListener('error', (e) => {
        resolve();
      });
    })
  );

  const headerSize = 300;
  const gridSpace = pageHeight - headerSize * 2;
  const rowHeight = gridSpace / order.length;
  const rowGap = 50;
  const boxWidth = pageWidth * 0.9;
  const boxX = (pageWidth - boxWidth) / 2 + 20;

  const roundRect = (x: number, y: number, width: number, height: number, radius: number) => {
    // Start with the top-left corner.
    context.beginPath();
    context.moveTo(x + radius, y);
    // Top edge
    context.lineTo(x + width - radius, y);
    context.quadraticCurveTo(x + width, y, x + width, y + radius);
    // Right edge
    context.lineTo(x + width, y + height - radius);
    context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    // Bottom edge
    context.lineTo(x + radius, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - radius);
    // Left edge
    context.lineTo(x, y + radius);
    context.quadraticCurveTo(x, y, x + radius, y);
    context.closePath();
  };

  const drawRow = (idx: number) => {
    context.fillStyle = DEFAULT_THEME.colors.dark[1];
    context.strokeStyle = DEFAULT_THEME.colors.dark[5];
    context.lineWidth = 3;
    const heightsAbove = headerSize + rowGap / 2 + idx * rowHeight;

    const boxHeight = rowHeight - rowGap;

    const songData = SONG_DATA[order[idx]];

    const boxY = heightsAbove;

    roundRect(boxX - 20, heightsAbove - 10, boxWidth, boxHeight + 20, 10);
    context.stroke();

    const padding = 0;

    context.fillStyle = TIER_COLOR_SWATCH[idx];

    context.fillStyle = songData.artist === 'Drake' ? '#B197FC' : DEFAULT_THEME.colors.pink[6];

    const positionHeight = boxHeight - padding * 2;
    roundRect(boxX + padding, heightsAbove + padding, 10, positionHeight, 10);
    context.fill();

    context.fillStyle = 'white';
    fillText(context, `${idx + 1}`, {
      font: SatoshiVariable.style.fontFamily,
      rect: {
        x: boxX + positionHeight / 2,
        y: heightsAbove + padding,
        width: positionHeight,
        height: positionHeight,
      },
    });

    imagePromises.push(
      new Promise<void>((resolve) => {
        const x = boxX + positionHeight + 30;
        const y = heightsAbove;
        const image = new Image(boxHeight, boxHeight);
        image.setAttribute('crossorigin', 'anonymous'); // works for me
        image.src = SONG_DATA[order[idx]].thumbnail.toURL();
        image.addEventListener('load', (e) => {
          context.save();
          function roundedImage(width: number, height: number, radius: number) {
            if (!context) return;
            context.beginPath();
            context.moveTo(x + radius, y);
            context.lineTo(x + width - radius, y);
            context.quadraticCurveTo(x + width, y, x + width, y + radius);
            context.lineTo(x + width, y + height - radius);
            context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            context.lineTo(x + radius, y + height);
            context.quadraticCurveTo(x, y + height, x, y + height - radius);
            context.lineTo(x, y + radius);
            context.quadraticCurveTo(x, y, x + radius, y);
            context.closePath();
          }

          roundedImage(boxHeight, boxHeight, 10);
          context.clip();
          context.drawImage(image, x, y, boxHeight, boxHeight);

          context.restore();
          resolve();
        });

        image.addEventListener('error', (e) => {
          resolve();
        });
      })
    );

    context.fillStyle = '#FFFFFF';

    fillText(context, songData.name, {
      font: SatoshiVariable.style.fontFamily,
      rect: {
        x: boxX + positionHeight * 2 + 50 + (boxWidth - (boxX + positionHeight * 2)) / 2,
        y: heightsAbove + positionHeight / 2 - (positionHeight * 0.4) / 2,
        width: boxWidth - (boxX + positionHeight * 2),
        height: positionHeight * 0.4,
      },
    });
  };

  // context.fillStyle = '#2C2E33';
  // roundRect(boxX, headerSize + rowGap / 2, boxWidth, gridSpace, 20);
  // context.fill();

  for (let index = 0; index < order.length; index += 1) {
    drawRow(index);
  }

  await Promise.all(imagePromises);
  const finalUrl = await new Promise<string | Blob>((resolve) => {
    canvas.toBlob(
      (tBlob) => {
        const finalBlob = tBlob;
        if (finalBlob) {
          if (asBlob) {
            resolve(finalBlob);
          } else {
            const url = URL.createObjectURL(finalBlob);
            resolve(url);
          }
        }
      },
      'image/png',
      1.0
    );
  });

  return finalUrl;
};
